<template>
  <Header
    :home-page-link="CONSTANTS.BASE_ROUTES.HOME"
    :headerlogo-title="labels.ALT_IMAGES.ANALYZE_LOGO"
    :is-homepage="false"
    :add-bottom-border="routeIsProjectList"
  />

  <v-snackbar
    v-model="displayAlertMsg.isShown"
    :timeout="
      displayAlertMsg.type === CONSTANTS.ALERT_VIEW.ALERT_TYPE
        ? CONSTANTS.SNACKBAR_SUCCESS_TIMEOUT
        : CONSTANTS.SNACKBAR_ERROR_TIMEOUT
    "
    fixed
    location="bottom"
    color="transparent"
    variant="tonal"
    center
    class="elevation-0"
    :min-width="CONSTANTS.ALERT_VIEW.MIN_WIDTH"
  >
    <VueAlert
      v-if="displayAlertMsg.isShown"
      :key="KeyAlert"
      :message="displayAlertMsg.message"
      :type="displayAlertMsg.type"
      :class="CONSTANTS.ALERT_VIEW.VUE_ALERT_CLASS"
    />
  </v-snackbar>
  <Sidebar
    v-if="!routeIsProjectList"
    :key="'sidebar_' + keySidebar"
    :sidebar-name="sidebarName"
    :items="menu"
    :header="header"
  />

  <div id="main-wrapper" class="main-wrapper bg-background d-flex">
    <v-container fluid>
      <router-view :has-route-changed="hasRouteChanged" />
    </v-container>
  </div>
</template>

<script lang="ts" setup>
  import Header from '@/components/Header/Header.vue'
  import Sidebar from '@/components/Sidebar/Sidebar.vue'

  import { scrollToTop } from '@/utils/helpers'
  import { AlertData } from '@/models/alert-data.model'
  import VueAlert from '@/components/VueAlert/VueAlert.vue'
  import notifMessage from '@/translations/notifMessage.json'
  import labels from '@/translations/labels.json'
  import CONSTANTS from '@/constants/Config.constants'
  import { onMounted, ref } from 'vue'
  import { useDisplay } from 'vuetify'
  import { EventBus } from '@/event-bus'
  import { useRouteStore } from '@/stores/routeStore'
  import { computed } from 'vue'
  import { ServiceKeys } from '@/services/symbols'
  import { injectTyped } from '@/inject'

  const routeStore = useRouteStore()
  const hasRouteChanged = ref(true)
  const alertKey = ref(0)
  const keyProjectList = ref(0)
  const keyProjectOverview = ref(0)
  const keySidebar = ref(0)
  const KeyAlert = ref(0)

  const menu = ref([])
  const header = ref([])
  const sidebarName = ref('')
  const contentPadding = ref({ paddingLeft: '250px' })

  const { mdAndDown, md } = useDisplay()
  const defaultContentPadding = ref({ paddingLeft: '70' })
  const expandedSidebar = ref(false)

  const displayAlertMsg = ref<AlertData>({
    type: 'error',
    message: '',
    isShown: false,
  })

  const routeIsProjectList = computed((): boolean => {
    if (routeStore.path) {
      return routeStore.path.includes('projectlist')
    } else return false
  })

  const syncStoreAndRouteService = injectTyped(ServiceKeys.sync)

  onMounted(() => {
    if (!syncStoreAndRouteService) {
      throw Error(notifMessage.ERROR_ALERTS.SOMETHING_WENT_WRONG)
    }
    syncStoreAndRouteService.keepStoreAndRouteInSync()
  })

  onMounted(() => {
    EventBus.on('showTopAlertMessage', (data: AlertData) => {
      displayAlertMsg.value.type = data.type
      displayAlertMsg.value.message = data.message
      displayAlertMsg.value.isShown = data.isShown
      scrollToTop()
      forceRerender()
    })

    EventBus.on('extendSidebar', (data: any) => {
      if (mdAndDown) {
        if (md) {
          contentPadding.value.paddingLeft = defaultContentPadding.value.paddingLeft
        } else {
          //TODO handle other case for sidebar
        }
      } else {
        if (data.sidebarWidth > 0) {
          contentPadding.value.paddingLeft = `${data.sidebarWidth - 6}px`
        }
      }
      expandedSidebar.value = data.expanded
    })
  })

  function forceRerender(): void {
    alertKey.value++
    keyProjectList.value++
    keyProjectOverview.value++
    keySidebar.value++
    KeyAlert.value++
  }
</script>

<!-- Intentionally not scoped for this component -->
<style lang="scss">
  @use '../../assets/styles/app.scss';

  .main-wrapper {
    margin-top: 2rem;
    margin-bottom: 0rem;
    padding-top: 2rem;
    background-color: rgb(var(--v-theme-background));
    position: relative;
    max-height: min-content;
  }

  .v-main {
    padding-top: 0px;
  }
</style>
